import { orderBy } from "lodash";

export const customOrderByDESC = (data) => {
  const sortedArray = orderBy(data, ["temp"], ["desc"]);
  return sortedArray;
};

export const customOrderByASC = (data) => {
  const sortedArray = orderBy(data, ["temp"], ["asc"]);
  return sortedArray;
};
